module.exports = __webpack_public_path__ + "img/Inspiration_Kontakt.c2f98c95.jpg";